// Formato: fase de liga + eliminatoria directa — 25 de octubre
const GROUPS = ["A", "B", "C", "D"].map((g) => ({
  name: `GRUPO ${g}`,
  slots: Array.from({ length: 4 }).map((_, i) => `TBD · ${g}${i + 1}`),
}));

const KO_ROUNDS = [
  {
    name: "CUARTOS",
    matches: Array.from({ length: 4 }).map((_, i) => ({
      home: "TBD",
      away: "TBD",
      label: `QF-${String(i + 1).padStart(2, "0")}`,
    })),
  },
  {
    name: "SEMIFINALES",
    matches: Array.from({ length: 2 }).map((_, i) => ({
      home: "TBD",
      away: "TBD",
      label: `SF-${String(i + 1).padStart(2, "0")}`,
    })),
  },
  {
    name: "FINAL",
    matches: [{ home: "?", away: "?", label: "FINAL" }],
  },
];

const Bracket = () => {
  return (
    <section
      id="bracket"
      data-testid="bracket-section"
      className="relative bg-[#070707] py-24 sm:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-16">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-[#EAB308] mb-4">
              / 03 · El Cuadro
            </div>
            <h2 className="font-display text-5xl sm:text-6xl uppercase tracking-tight leading-none">
              Camino al
              <br />
              <span className="text-[#EAB308]">título.</span>
            </h2>
          </div>
          <div className="text-white/60 max-w-md font-body text-sm">
            Primero fase de liga en grupos. Después, eliminatoria directa. Se
            juega en dos campos de fútbol 11 divididos en mitades: 4 partidos
            simultáneos.
          </div>
        </div>

        {/* Phases header */}
        <div className="grid grid-cols-2 mb-6 gap-px bg-white/10">
          <div className="bg-[#0a0a0a] px-6 py-4 flex items-center justify-between">
            <div className="text-xs tracking-[0.3em] uppercase text-white/50">
              Fase 1 · Liga
            </div>
            <div className="text-xs tracking-[0.3em] uppercase text-[#EAB308]">
              Grupos
            </div>
          </div>
          <div className="bg-[#0a0a0a] px-6 py-4 flex items-center justify-between">
            <div className="text-xs tracking-[0.3em] uppercase text-white/50">
              Fase 2 · KO
            </div>
            <div className="text-xs tracking-[0.3em] uppercase text-[#EAB308]">
              Eliminatoria directa
            </div>
          </div>
        </div>

        {/* League phase - groups */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 mb-12" data-testid="league-groups">
          {GROUPS.map((group, gIdx) => (
            <div
              key={group.name}
              data-testid={`league-group-${gIdx}`}
              className="bg-[#0a0a0a] p-5 group hover:bg-[#0f0f0f] transition-colors"
            >
              <div className="flex items-center gap-2 mb-4">
                <span className="text-[#EAB308]">●</span>
                <span className="text-[10px] tracking-[0.3em] uppercase text-white/60">
                  {group.name}
                </span>
              </div>
              <div className="space-y-2">
                {group.slots.map((slot) => (
                  <div
                    key={slot}
                    className="flex items-center justify-between border-b border-white/5 last:border-b-0 pb-2 last:pb-0"
                  >
                    <span className="text-[11px] tracking-wider uppercase text-white/50">
                      TBD
                    </span>
                    <span className="text-[9px] tracking-[0.2em] uppercase text-white/25">
                      {slot.split("· ")[1]}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* KO phase - bracket */}
        <div className="overflow-x-auto pb-4">
          <div className="grid grid-cols-3 gap-4 sm:gap-8 min-w-[720px]">
            {KO_ROUNDS.map((round, rIdx) => (
              <div key={round.name} className="flex flex-col">
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4 pl-2 flex items-center gap-2">
                  <span className="text-[#EAB308]">●</span> {round.name}
                </div>
                <div
                  className="flex flex-col justify-around flex-1 gap-3"
                  style={{ minHeight: `${KO_ROUNDS[0].matches.length * 56}px` }}
                >
                  {round.matches.map((m, i) => (
                    <div
                      key={m.label}
                      data-testid={`bracket-match-${rIdx}-${i}`}
                      className="group relative bg-[#0a0a0a] border border-white/10 hover:border-[#EAB308]/50 transition-colors"
                    >
                      <div className="px-3 py-2.5 flex items-center justify-between border-b border-white/5">
                        <span className="text-[11px] tracking-wider uppercase text-white/70 font-medium">
                          {m.home}
                        </span>
                        <span className="text-[10px] text-white/30">vs</span>
                      </div>
                      <div className="px-3 py-2.5 flex items-center justify-between">
                        <span className="text-[11px] tracking-wider uppercase text-white/70 font-medium">
                          {m.away}
                        </span>
                        <span className="text-[9px] tracking-[0.2em] uppercase text-white/30">
                          {m.label}
                        </span>
                      </div>
                      <div className="absolute -right-2 top-1/2 -translate-y-1/2 w-1 h-1 bg-[#EAB308] opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-white/40 tracking-[0.2em] uppercase">
          <div className="flex items-center gap-3">
            <div className="w-8 h-px bg-white/20" />
            Formato provisional · el sorteo de grupos se publicará al cierre de inscripciones
          </div>
          <div className="text-[#EAB308]/70">25 Octubre · Totem Sports Center · Tordera</div>
        </div>
      </div>
    </section>
  );
};

export default Bracket;
